import type { CanvasCollaborators } from '@confluence/team-presence/entry-points/presenceTypes';

import { ContentTypesActionsService } from './content-types-actions-service';

export const contentCollaboratorsService = new ContentTypesActionsService<CanvasCollaborators>();
